module.exports = __webpack_public_path__ + "img/icon-bedroom.699437eb.svg";